import { Formik } from "formik";
import React, { useState } from "react";
import { Form } from "semantic-ui-react";
import useFetch from "../../../hooks/use-fetch";
import IconButton from "../../ui/button";
import "../style.scss";

const EditEnding = ({ request, getSubscriptionDetails }) => {
  const api = useFetch();
  const [addingEnding, setAddingEnding] = useState(false);
  const initialValues = {
    RequestGuid: request.guid,
    EndingText: request.ending ?? "",
  };

  const updateRequestEnding = async (payload) => {
    console.log(payload);
    await api.fetchData("api/subscriptions/edit_ending", "PUT", payload);
    setAddingEnding(false);
    getSubscriptionDetails();
  };

  return (
    <div>
      {!addingEnding ? (
        <div>
          <div>
            {request.ending ? (
              <div className="campaign-question-group">
                <div className="space-between-container">
                  <h4>Campaign Ending</h4>
                  <IconButton
                    title="Edit Ending"
                    text="Edit"
                    type="submit"
                    onClick={() => {
                      setAddingEnding(true);
                    }}
                    color="red"
                  />
                </div>
                <div>{request.ending}</div>
              </div>
            ) : (
              <div className="campaign-question-group">
                <div className="space-between-container">
                  <div>
                    Thank you for answering, your responses have been recorded.
                    (Default Ending)
                  </div>
                  <IconButton
                    title="Add"
                    text="Add Ending"
                    type="submit"
                    onClick={() => {
                      setAddingEnding(true);
                    }}
                    color="red"
                  />
                </div>
              </div>
            )}
          </div>
        </div>
      ) : (
        // Add or edit the Ending here
        <div className="campaign-question-groups">
          <Formik initialValues={initialValues}>
            {({ values, setFieldValue, handleBlur }) => (
              <Form>
                <Form.TextArea
                  id="Ending"
                  label="Campaign Ending"
                  value={values.EndingText}
                  placeholder="Message to read after questions have been answered."
                  onChange={(e) => setFieldValue(`EndingText`, e.target.value)}
                  onBlur={handleBlur}
                />
                <IconButton
                  title="Save"
                  text="Save Ending"
                  type="submit"
                  onClick={() => {
                    updateRequestEnding(values);
                  }}
                  color="red"
                />
                <IconButton
                  title="Cancel"
                  text="Cancel"
                  onClick={() => {
                    setAddingEnding(false);
                  }}
                  color="taupe"
                />
              </Form>
            )}
          </Formik>
        </div>
      )}
    </div>
  );
};
export default EditEnding;
